import { createUseStyles } from 'react-jss';
var useStyles = createUseStyles(function (_ref) {
  var palette = _ref.palette;
  return {
    logo: function logo(props) {
      return {
        color: props.color === 'alt' ? palette.text.light : palette.primary.main,
        fill: props.color === 'alt' ? palette.text.light : palette.primary.main
      };
    }
  };
});
export default useStyles;
//# sourceMappingURL=useStyles.js.map